export default [{
  name: 'jpcash',
  namespaced: true,
  state: {
    model: {
      Pessoa: {
        PessoaDadosContato: {},
        PessoaBanco: {},
        PessoaEndereco: {},
        TipoPessoa: null,
      },
      Split: {
        IncluirSplit: null
      },
      Parcela: {},
    },
    dadosIniciais: {}
  },
  mutations: {
    model (state, obj) {
      state.model = obj
    },
    dadosIniciais (state, obj) {
      state.dadosIniciais = obj
    }
  },
  getters: {
    model (state) {
      return state.model
    },
    dadosIniciais (state) {
      return state.dadosIniciais
    }
  },
  actions: {
    clearModel ({ commit }) {
      const data = {
        Pessoa: {
          PessoaBanco: {},
          PessoaDadosContato: {},
          PessoaEndereco: {},
          TipoPessoa: null,
        },
        Parcela: {},
        PessoaDadosContato: {},
        Split: {},
        cessionario: {}
      }
      commit('model', data)
    }
  },
}]
